import { useTranslation } from "react-i18next";
import { type Badges } from "~/utils/data_warehouse/client";

interface Props {
  badges: Badges | null;
  hasError: boolean;
  loading: boolean;
}

const Badge = ({ badgeKey, isEarned }: { badgeKey: string; isEarned: boolean }) => {
  const message = `${badgeKey}: ${isEarned ? "Earned" : "Not Earned"}`;

  return <div>{message}</div>;
};

export const Content = ({ badges, hasError, loading }: Props) => {
  const { t } = useTranslation("job_trust_profiles");

  if (loading) {
    return <div>{"Loading..."}</div>;
  }

  if (hasError) {
    return <div>{t("error")}</div>;
  }

  if (!badges) {
    return null;
  }

  return (
    <div>
      {(Object.keys(badges) as (keyof Badges)[]).map((key) => (
        <Badge key={key} badgeKey={key} isEarned={badges[key]} />
      ))}
    </div>
  );
};
